import React from "react";

/** A missing value renders as a muted dash; text as a paragraph; else as is. */
const renderValue = (value: React.ReactNode): React.ReactNode => {
  if (value == null || value === "") {
    return <p className="text-sm text-gray-500">-</p>;
  }
  if (typeof value === "string" || typeof value === "number") {
    return <p className="text-sm text-semantic-text-primary">{value}</p>;
  }
  return value;
};

/**
 * Same row markup PortDetailsCard uses: label left, value right, border-b.
 * Shared by the Extended PoP and Carrier Access detail cards.
 */
export const DetailRow: React.FC<{
  label: string;
  value?: React.ReactNode;
  isLast?: boolean;
}> = ({ label, value, isLast = false }) => (
  <div
    className={`flex justify-between w-full py-1 ${isLast ? "" : "border-b"}`}
  >
    <h3 className="text-sm text-semantic-text-primary">{label}</h3>
    <div className="flex items-center gap-2 min-w-0">{renderValue(value)}</div>
  </div>
);
